import React, { useState, useEffect } from 'react';
import { openSecureUrl, ALLOWED_DOMAINS } from '../utils/security';

// Datos
import { content } from '../data/content';
import { imageData } from '../data/images';

// Componentes comunes
import Navigation from './common/Navigation';
import Footer from './common/Footer';
import WhatsAppFloat from './common/WhatsAppFloat';

// Secciones
import HeroSection from './sections/HeroSection';
import AboutSection from './sections/AboutSection';
import ExperiencesSection from './sections/ExperiencesSection';
import TestimonialsSection from './sections/TestimonialsSection';
import GallerySection from './sections/GallerySection';
import ServicesSection from './sections/ServicesSection';
import LocationSection from './sections/LocationSection';
import BookingSection from './sections/BookingSection';

const CasaColoresApp = () => {
  const [language, setLanguage] = useState('es');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Contenido actual basado en idioma
  const currentContent = content[language];

  // Cambio automático de imágenes en el hero
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        (prevIndex + 1) % imageData.heroImages.length
      );
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  // Funciones de navegación
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  const toggleLanguage = () => {
    if (language === 'es') {
      setLanguage('en');
    } else if (language === 'en') {
      setLanguage('pt');
    } else if (language === 'pt') {
      setLanguage('fr');
    } else {
      setLanguage('es');
    }
  };

  const openWhatsApp = () => {
    const message = encodeURIComponent(currentContent.booking.whatsappMessage);
    const phoneNumber = "543883316388";
    const url = `https://wa.me/${phoneNumber}?text=${message}`;
    
    openSecureUrl(url, ALLOWED_DOMAINS.WHATSAPP);
  };

  const openBooking = () => {
    const bookingUrl = 'https://www.booking.com/hotel/ar/casa-colores.es.html';
    openSecureUrl(bookingUrl, ALLOWED_DOMAINS.BOOKING);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Navigation */}
      <Navigation 
        language={language}
        currentContent={currentContent}
        isMenuOpen={isMenuOpen}
        setIsMenuOpen={setIsMenuOpen}
        scrollToSection={scrollToSection}
        toggleLanguage={toggleLanguage}
      />

      {/* Hero Section */}
      <HeroSection 
        language={language}
        currentContent={currentContent}
        currentImageIndex={currentImageIndex}
        scrollToSection={scrollToSection}
      />

      {/* About Section */}
      <AboutSection 
        language={language}
        currentContent={currentContent}
      />

      {/* Experiences Section - "The Casa Colores Experience" */}
      <ExperiencesSection 
        language={language}
        currentContent={currentContent}
        scrollToSection={scrollToSection}
      />

      {/* Testimonials Section - "Lo que dicen nuestros huéspedes" */}
      <TestimonialsSection 
        language={language}
        currentContent={currentContent}
      />

      {/* Gallery Section - "Nuestros Espacios" */}
      <GallerySection 
        language={language}
        currentContent={currentContent}
      />

      {/* Services Section */}
      <ServicesSection 
        currentContent={currentContent}
      />

      {/* Location Section */}
      <LocationSection 
        language={language}
        currentContent={currentContent}
      />

      {/* Booking Section */}
      <BookingSection 
        currentContent={currentContent}
        openWhatsApp={openWhatsApp}
        openBooking={openBooking}
      />

      {/* Footer */}
      <Footer 
        currentContent={currentContent}
        openWhatsApp={openWhatsApp}
        openBooking={openBooking}
      />

      {/* WhatsApp Float */}
      <WhatsAppFloat 
        currentContent={currentContent}
      />
    </div>
  );
};

export default CasaColoresApp;
